import classNames from 'classnames';
import Typography from '@/components/atoms/typography/typography';
import ConfigurationFlowStepIndicator from '@/components/modules/configuration-flow/configuration-flow-step-indicator/configuration-flow-step-indicator';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './configuration-flow-header.module.scss';

export interface ConfigurationFlowHeaderProps {
  /** Additional class names */
  className?: string;
  /** The index of the current step */
  currentStep: number;
  /** The headline display */
  headline: string;
  /** The steps of the configuration flow */
  steps: Content.Components['ConfigurationFlowModuleDto']['steps'];
}

const ConfigurationFlowHeader = ({
  className,
  currentStep,
  headline,
  steps,
}: ConfigurationFlowHeaderProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      <Typography className={styles.headline} tagStyle="displayMedium">
        {headline}
      </Typography>

      {steps.length > 1 && (
        <ConfigurationFlowStepIndicator
          currentStep={currentStep}
          steps={steps}
        />
      )}
    </div>
  );
};

ConfigurationFlowHeader.displayName = 'ConfigurationFlowHeader';

export default ConfigurationFlowHeader;
